module.exports = __webpack_public_path__ + "static/img/byconcept-06.bb8d50c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-06.webp
// module id = 72
// module chunks = 0